// @flow

import React, { Component } from "react";
import classNames from "classnames";
import { Typeahead } from "react-bootstrap-typeahead";

import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";
import type { SelectWidget as SelectWidgetProps } from "react-jsonschema-form/lib/components/widgets/SelectWidget";
import "react-bootstrap-typeahead/css/Typeahead.css";

type Props = $Exact<{
  ...SelectWidgetProps,
  options: Object,
}>;

type ComponentState = $Exact<{
  defaultSelected: Array<
    $Exact<{
      label: string | number,
      value: string | number,
    }>,
  >,
}>;

export class MultipleTypeaheadSelect extends Component<Props, ComponentState> {
  state = {
    defaultSelected: this.defaultSelected,
  };

  handleChange = (data: Object): void => {
    this.props.onChange(data.map(item => item.value));
  };

  get defaultSelected() {
    return Array.isArray(this.props.value)
      ? this.props.value
          .reduce((acc, current) => [...acc, ...Object.values(current)], [])
          .map(item => this.props.options.enumOptions.find(option => option.value === item))
      : [];
  }

  render() {
    const props = Object.assign({}, this.props, {
      readOnly: this.props.readonly,
      autoFocus: this.props.autofocus,
      onChange: this.handleChange,
      options: this.props.options.enumOptions,
      defaultSelected: this.state.defaultSelected,
    });

    delete props.value;
    delete props.readonly;
    delete props.formContext;
    delete props.autofocus;
    delete props.rawErrors;
    delete props.registry;
    delete props.schema;

    return (
      <React.Fragment>
        <Typeahead
          {...props}
          labelKey="label"
          multiple
          className={classNames("mt-1 multiple-typeahead-select", this.props.className)}
        />
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
      </React.Fragment>
    );
  }
}

export default MultipleTypeaheadSelect;
